"use client";

import { Card, CardTitle, CardHeader, CardContent, CardDescription } from "@admin/components/ui/card";
import { Input } from "@admin/components/ui/input";
import { Button } from "@admin/components/ui/button";
import { Label } from "@admin/components/ui/label";
import { signIn } from "next-auth/react";
import { useRouter } from "next/navigation";
import { useState } from "react";
import { toast } from "sonner";

export default function LoginPage() {
    const router = useRouter();
    const [loading, setLoading] = useState(false);
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const result = await signIn("credentials", {
                login,
                password,
                redirect: false,
            });

            if (result?.error) {
                toast.error("Неверный логин или пароль");
            } else {
                router.push("/");
            }
        } catch {
            toast.error("Ошибка при входе");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex justify-center items-center h-screen">
            <div className="w-full max-w-sm space-y-4">
                <Card>
                    <CardHeader>
                        <CardTitle className="text-center text-2xl font-bold">
                            Войти в систему
                        </CardTitle>
                        <CardDescription className="text-center text-sm">
                            Введите логин и пароль для входа
                        </CardDescription>
                    </CardHeader>
                    <CardContent>
                        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                            <div className="flex flex-col gap-2">
                                <Label htmlFor="login">Логин</Label>
                                <Input
                                    id="login"
                                    type="text"
                                    value={login}
                                    onChange={(e) => setLogin(e.target.value)}
                                    placeholder="Введите логин"
                                    required
                                />
                            </div>
                            <div className="flex flex-col gap-2">
                                <Label htmlFor="password">Пароль</Label>
                                <Input
                                    id="password"
                                    type="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Введите пароль"
                                    required
                                />
                            </div>
                            <Button type="submit" disabled={loading} className="w-full">
                                {loading ? "Загрузка..." : "Войти"}
                            </Button>
                        </form>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
